import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/CookieAuth/auth.service';
import { Sr } from 'src/app/interfaces/sr';
import { SrDetalle } from 'src/app/interfaces/srDetalle';
import { EstadoService } from 'src/app/service/estado.service';
import { SrService } from 'src/app/service/sr.service';

@Component({
  selector: 'app-cliente-pedidos',
  templateUrl: './cliente-pedidos.component.html',
  styleUrls: ['./cliente-pedidos.component.css']
})
export class ClientePedidosComponent implements OnInit {
  public estados?:any[];
  name:string="Mariano test";
  idsr:number=0;
  idet:number=0;
  dni:number=0;
  desde:Date=new Date();
  hasta:Date=new Date();
  estado:number=0;
  public sr?: any[];
  constructor(private srService:SrService, private cookie: AuthService, private dialog: MatDialog,private estadoService:EstadoService) {
    this.estados=this.estadoService.get()
    this.desde.setFullYear(2020)
  }

  ngOnInit(): void {
    this.buscar();
  }
  open(id:number){
    window.location.href = "/cliente/"+ id+ "/0";
  }
  buscar(){
    this.srService.getHistorico(this.idsr,this.idet,this.dni,this.desde,this.hasta,this.estado).then((item:any[])=>{
      this.sr=item;
      // console.log(item);
    });
  }
}
